"use client";

import { c as _c } from "react/compiler-runtime";
import { useSEOBannerVisibility } from "@/hooks/use-seo-banner-visibility";
import { useSearchPageMapData } from "@/providers/search";
import { SearchList } from "../list";
import { SEOContentForSearch } from "../list/seo/content";
import { SearchMap } from "../map";
import { ProjectList } from "../project-list";
export function DesktopLayout() {
  const $ = _c(16);
  const {
    shouldShowSeoBanner,
    totalPropertiesCount
  } = useSEOBannerVisibility();
  const mode = useSearchPageMapData(_temp);
  let t0;
  if ($[0] !== mode) {
    t0 = mode === "project" && <ProjectList className="h-full" />;
    $[0] = mode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== mode) {
    t1 = mode !== "project" && <SearchList className="h-full" />;
    $[2] = mode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="w-1/2 h-full">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-1/2 h-full"><SearchMap /></div>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2) {
    t4 = <div className="flex w-full h-[calc(100vh-var(--header-height))]">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== shouldShowSeoBanner || $[11] !== totalPropertiesCount) {
    t5 = shouldShowSeoBanner && totalPropertiesCount > 0 && <div className="w-full bg-gradient-to-r from-[#251821] to-[#31202C] min-h-[20vh] flex items-center justify-center"><SEOContentForSearch /></div>;
    $[10] = shouldShowSeoBanner;
    $[11] = totalPropertiesCount;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="w-full h-full flex flex-col">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp(state) {
  return state.mode;
}